
import {APP_DI_CONFIG} from '../../../app/app-config.module';
/**
 * Modelo de datos para gestionar la URL del back-end.
 *
 * @export
 * @class EndPointActions
 */
export class EndPointParams{

    /**
     * URL del backend.
     *
     * @private
     * @type {string}
     * @memberof EndPointActions
     */
    private _backendURL: string = APP_DI_CONFIG.urlWithoutProtocol;

    /**
     * Subdominio de cliente.
     *
     * @private
     * @type {string}
     * @memberof EndPointParams
     */
    private _client: string = APP_DI_CONFIG.client;

    /**
     * Protocolo (http/https).
     *
     * @private
     * @type {string}
     * @memberof EndPointParams
     */
    private _protocol: string = APP_DI_CONFIG.protocol;


    /**
     * Path de la API.
     *
     * @private
     * @type {string}
     * @memberof EndPointActions
     */
    private _apiPath: string = APP_DI_CONFIG.apiPath;

    /**
     * URL completa.
     *
     * @private
     * @type {string}
     * @memberof EndPointParams
     */
    private _url: string = '';

    static readonly class = {
        REAL: 'real' as string
    };


    static readonly operation = {
        getParams: 'getParams' as string,
        login: 'login' as string,
        listaOfsInternas: 'real/listaOfsInternas' as string,
        cambiarOperario: 'real/cambiarOperario' as string,
        cambiarOf: 'real/cambiarOf' as string,
        entrarOperario: 'real/entrarOperario' as string,
        salirOperario: 'real/salirOperario' as string,
        getOfsOperario: 'manual/getOfsOperario' as string,
        getOfsDropdown: '/manual/getOfsDropdown' as string,
        getProductosOfDropdown: 'manual/getProductosOfDropdown' as string,
        getOpsProdOfDropdown: 'manual/getOpsProdOfDropdown' as string,
        anadirHorasOpProdOf: 'manual/anadirHorasOpProdOf' as string,
        modHorasOpProdOf: 'manual/modHorasOpProdOf' as string,
        delHorasOpProdOf: 'manual/delHorasOpProdOf' as string,
        operario: 'operario' as string,
        getLogo: 'getLogo' as string,
        getInformeTest: 'informe/450' //450: informe hores extres
    };


    /**
     *Creates an instance of EndPointActions.

     * @param {AppConfig} endpoint
     * @memberof EndPointActions
     */
    constructor(endpoint: {
        protocol?: string
        backendURL?: string,
        client?: string,
        apiPath?: string
    } = {}){
        if(typeof endpoint.backendURL != 'undefined') this._backendURL = endpoint.backendURL;
        if(typeof endpoint.apiPath != 'undefined') this._apiPath = endpoint.apiPath;
        if(typeof endpoint.client != 'undefined') this._client = endpoint.client;
        if(typeof endpoint.protocol != 'undefined') this._protocol = endpoint.protocol;

        let sClient = this._client?this._client + '.':'';

        this._url = `${this._protocol}://${sClient}${this._backendURL}/${this._apiPath}`;
    }


    getUrl(action: string, endSlash: boolean = false ){
        return this._url + '/' + action + (endSlash?'/':'');
    }
}



// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/end-point-params.model.ts